export const moduleMappingConstants = {
  RETRIEVE_DATASMAP: 'RETRIEVE_DATASMAP'
}
